import { useEffect } from 'react'

import { MerchantAutoenrollmentInitContract } from '@/AutoEnrollment/application'
import { createApiMerchantAutoenrollmentInitRepository } from '@/AutoEnrollment/infrastructure'
import { useMetaResponseHandler } from '@/Shared/ui/form'

export const useMerchantAutoenrollmentInitController = (): void => {
  const { handleMetaResponse } = useMetaResponseHandler()

  useEffect(() => {
    const fetchInit = async () => {
      const contract = MerchantAutoenrollmentInitContract(
        createApiMerchantAutoenrollmentInitRepository(),
      )
      const response = await contract.getMerchantAutoenrollmentInit()
      handleMetaResponse(response.meta, undefined, { notifySuccess: false })
    }

    fetchInit()
  }, [])
}
